import {Component, OnInit, Input, OnChanges, Output, EventEmitter, ElementRef, ViewChild, HostListener} from '@angular/core';
import {AuthService} from '../../../core/auth/auth.service';

@Component({
  selector: 'app-editable-field',
  templateUrl: './editable-field.component.html',
  styleUrls: ['./editable-field.component.scss'],
  host: {
    '(document:mousedown)': 'onClick($event)'
  }
})
export class EditableFieldComponent implements OnInit, OnChanges {

  @Input() value: string;
  @Input() label: string;
  @Input() fieldName: string;

  @Input() editable: boolean;

  @Output() edit = new EventEmitter();

  @ViewChild('popover') popover;

  showPopup: boolean;

  intermediateValue: string;

  @HostListener('document:keyup', ['$event']) onKeyDown(event) {
    const e = <KeyboardEvent> event;
    if (e.keyCode === 13) {
      this.save();
    } else if (e.keyCode === 27 && this.showPopup) {
      this.hide();
    }
  }

  constructor() {}

  ngOnInit() {
  }

  ngOnChanges() {
    this.intermediateValue = this.value;
  }

  private onClick(event): void {
    if (this.showPopup
      && (
        !this.popover._popover
        || !this.popover._popover._componentRef
        || !this.popover._popover._componentRef.location
        || !this.popover._popover._componentRef.location.nativeElement
        || !this.popover._popover._componentRef.location.nativeElement.contains(event.target)
      )
    ){
      this.hide();
    }
  }

  hide() {
    this.showPopup = false;
    this.popover.hide();
  }

  togglePopup() {
    if (this.editable) {
      this.showPopup = !this.showPopup;
    }
  }

  show() {
    this.showPopup = true;
    this.popover.show();
  }

  save() {
    const data = {};
    if (this.intermediateValue !== this.value) {
      data[this.fieldName] = this.intermediateValue;
      this.edit.next(data);
    }
    this.showPopup = false;
  }

}



// WEBPACK FOOTER //
// ./client/app/components/shared/editable-field/editable-field.component.ts